import React from 'react'

export const ArrivalCarpoolIcon: React.FC<{ color?: string; size?: string | number }> = ({
  color = '#E5C265',
  size = '44',
}) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 44 44' fill='none'>
    <g clipPath='url(#clip0_750_11738)'>
      <path
        d='M14.6666 21.9993C14.6666 23.9443 15.4392 25.8095 16.8145 27.1848C18.1898 28.5601 20.055 29.3327 22 29.3327C23.9449 29.3327 25.8101 28.5601 27.1854 27.1848C28.5607 25.8095 29.3333 23.9443 29.3333 21.9993C29.3333 20.0544 28.5607 18.1892 27.1854 16.8139C25.8101 15.4386 23.9449 14.666 22 14.666C20.055 14.666 18.1898 15.4386 16.8145 16.8139C15.4392 18.1892 14.6666 20.0544 14.6666 21.9993Z'
        stroke={color}
        strokeWidth='2.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M7.33337 22H7.35171' stroke={color} strokeWidth='2.75' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M22 7.33398V7.35232' stroke={color} strokeWidth='2.75' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M36.6666 22H36.685' stroke={color} strokeWidth='2.75' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M22 36.666V36.6843' stroke={color} strokeWidth='2.75' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M11.5684 11.5691L11.55 11.5508'
        stroke={color}
        strokeWidth='2.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M32.4683 11.5691L32.45 11.5508'
        stroke={color}
        strokeWidth='2.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M32.45 32.4492L32.4683 32.4675'
        stroke={color}
        strokeWidth='2.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.55 32.4492L11.5684 32.4675'
        stroke={color}
        strokeWidth='2.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_750_11738'>
        <rect width='44' height='44' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
